/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from 'react'
import {
  Header,
  Footer,
  Loading,
  TopSectionLawyer,
  ProfileLawyerMap,
  Snackbar,
} from '../../../components/index'
import { useParams } from 'react-router-dom'
import { WebApi } from '../../../api/web'
import { userId } from '../../../services/authentication'
import { AiFillPhone } from 'react-icons/ai'
import { FaMapMarkerAlt, FaUserClock } from 'react-icons/fa'
import { GregorianToJalali } from '../../../utilities/convertTime'

const ServiceList = () => {
  const { id } = useParams()
  const [lawyer, setLawyer] = useState(null)
  const [lawyerId, setLawyerId] = useState(null)
  const [Time, setTime] = useState(null)
  const [like, setLike] = useState(false)
  const [countLike, setCountLike] = useState(0)
  const [comment, setComment] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    GetConsulting()
  }, [])

  const StoreComment = async () => {
    if (comment.length > 0) {
      setLoading(true)
      await WebApi.storeComment({
        lawyer: lawyerId,
        comment: comment,
      })
        .then((res) => {
          setLoading(false)
          if (res.data.data.commentStore) {
            Snackbar({
              title: 'موفق',
              message: 'نظر شما با موفقیت ثبت شد',
              type: 'success',
            })
            setComment('')
          }
        })
        .catch((err) => {
          setLoading(false)
        })
    }
  }

  const GetConsulting = async () => {
    await WebApi.singleConsulting(id)
      .then((res) => {
        setLawyerId(res.data.data.consulting.lawyer._id)
        setLawyer(res.data.data.consulting.lawyer)
        setTime(res.data.data.consulting.reserveTime)
        setCountLike(res.data.data.consulting.lawyer.likes.length)
        res.data.data.consulting.lawyer.likes.map((userLike) => {
          if (userLike == userId()) {
            setLike(true)
          }
        })
      })
      .catch((err) => {
        console.log('ccc', err)
      })
  }

  return (
    <>
      <Header title='لیست مشاوره های پرداخت شده' />
      <div className='container'>
        <div className='template-pages'>
          {lawyer && Time ? (
            <>
              <TopSectionLawyer
                {...{
                  like,
                  setLike,
                  lawyer,
                  countLike,
                  setCountLike,
                }}
                id={lawyerId}
              />
              <div className='about-lawer set-calendar'>
                <div>
                  <h2>{`${lawyer.fname} ${lawyer.lname}`}</h2>
                  <h5>{lawyer.title}</h5>
                </div>
                {document.number && (
                  <div className='license-number'>
                    <span>شماره پروانه وکالت</span>
                    <span>{document.number}</span>
                  </div>
                )}
              </div>
              <div className='layer-shadow'></div>
              <div className='contact-profile-lawyer'>
                <div className='nav'>
                  <div className='item'>
                    <span>
                      <AiFillPhone size={23} />
                    </span>
                    <span>شماره تماس وکیل</span>
                  </div>
                  <div>{lawyer.mobile.split(' ').join('')}</div>
                </div>
                <div className='nav'>
                  <div className='item'>
                    <span>
                      <FaMapMarkerAlt size={23} />
                    </span>
                    <span>نشانی دفتر</span>
                  </div>
                  <div>{lawyer.address}</div>
                </div>
                <div className='nav'>
                  <div className='item'>
                    <span>
                      <FaUserClock size={23} />
                    </span>
                    <span>تاریخ و زمان رزرو شده</span>
                  </div>
                  <div>
                    {GregorianToJalali(Time.date)} ساعت : {Time.time}
                  </div>
                </div>
              </div>
              <div className='map-lawyer-profile'>
                <ProfileLawyerMap lawyer={lawyer} />
              </div>
              <div className='form-comment'>
                <div className='title'>
                  <h3>فرم ارسال نظر</h3>
                </div>
                <textarea
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  placeholder='دیدگاه یا نظر خود را همین جا بنویسید...'
                ></textarea>
                <span
                  onClick={() => StoreComment()}
                  className='btn-form-detail-lawyer'
                >
                  نظر خود را ارسال کنید
                </span>
                <div className='layer-shadow'></div>
              </div>
            </>
          ) : (
            <Loading />
          )}
        </div>
      </div>
      <Footer />
    </>
  )
}
export default ServiceList
